import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";
import { armarFondo } from "../utils/fondoServicio";
const API_BASE = API_URL.replace("/api", "");

// 🔥 Estas son las únicas 3 "rutas" que el sistema reconoce de verdad
// (están fijas en el código de PadrePanel.js) — cualquier otro valor
// hace que el servicio no funcione al entrar como padre.
const RUTAS_VALIDAS = [
  { value: "/citas-colegio-2026", label: "Colegio (Primaria/Secundaria)" },
  { value: "/citas-cda-2026", label: "CDA" },
  { value: "/citas-kindergarten-2026", label: "Kindergarten" },
];


const GestionarServicios = () => {
  const [servicios, setServicios] = useState([]);
  const [configuraciones, setConfiguraciones] = useState([]);
  const [modo, setModo] = useState("listar"); // listar | crear | editar
  const [idEditando, setIdEditando] = useState(null);

  const [nombre, setNombre] = useState("");
  const [ruta, setRuta] = useState("");
  const [color, setColor] = useState("#2563eb");
  const [colorDifuminado, setColorDifuminado] = useState(false);
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);

  /* =======================
     CARGAR SERVICIOS
  ======================== */
const cargarServicios = async () => {
  const res = await axios.get(`${API_URL}/api/servicios?t=${Date.now()}`);
  setServicios(res.data || []);
};

const cargarConfiguraciones = async () => {
  const res = await axios.get(`${API_URL}/api/configuraciones-horarios`);
  setConfiguraciones(res.data || []);
};

/* =======================
   ASIGNAR CONFIGURACIÓN
======================== */
const asignarConfiguracion = async (servicioId, configuracionId) => {
  await axios.post(`${API_URL}/api/servicios/${servicioId}/configuracion`, {
    configuracion_id: configuracionId || null,
  });
  cargarServicios();
};

  useEffect(() => {
    cargarServicios();
    cargarConfiguraciones();
  }, []);

  /* =======================
     RESET FORM
  ======================== */
  const resetForm = () => {
    setModo("listar");
    setIdEditando(null);
    setNombre("");
    setRuta("");
    setColor("#2563eb");
    setColorDifuminado(false);
    setImagen(null);
    setPreview(null);
  };

  /* =======================
     IMAGEN
  ======================== */
  const onImagenChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImagen(file);
    setPreview(URL.createObjectURL(file));
  };

  /* =======================
     CREAR
  ======================== */
  const crearServicio = async () => {
    if (!nombre || !ruta) {
      alert("Nombre y ruta son obligatorios");
      return;
    }

    const fd = new FormData();
    fd.append("nombre", nombre);
    fd.append("ruta", ruta);
    fd.append("color", color);
    fd.append("color_difuminado", colorDifuminado ? "1" : "0");
    if (imagen) fd.append("imagen", imagen);

    try {
      await axios.post(`${API_URL}/api/servicios`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      resetForm();
      cargarServicios();
    } catch (err) {
      alert(err.response?.data?.message || "No se pudo crear el servicio");
    }
  };

  /* =======================
     EDITAR
  ======================== */
  const abrirEditar = (s) => {
    setModo("editar");
    setIdEditando(s.id);
    setNombre(s.nombre);
    setRuta(s.ruta);
    setColor(s.color || "#2563eb");
    setColorDifuminado(!!s.color_difuminado);

setPreview(s.imagen ? `${API_BASE}${s.imagen}?t=${Date.now()}` : null);

    setImagen(null);
  };

  const guardarEdicion = async () => {
    try {
      await axios.post(`${API_URL}/api/servicios/${idEditando}/nombre`, { nombre });
      await axios.post(`${API_URL}/api/servicios/${idEditando}/ruta`, { ruta });
      await axios.post(`${API_URL}/api/servicios/${idEditando}/color`, { color, color_difuminado: colorDifuminado });

      if (imagen) {
        const fd = new FormData();
        fd.append("imagen", imagen);

        await axios.post(`${API_URL}/api/servicios/${idEditando}/imagen`, fd);
      }

      resetForm();
      cargarServicios();
    } catch (err) {
      alert(err.response?.data?.message || "No se pudo guardar el servicio");
    }
  };

  /* =======================
     ORDEN (flechas ↑/↓ — controla en qué orden las ve
     el padre en "Seleccione un Servicio")
  ======================== */
  const moverOrden = async (index, direccion) => {
    const otroIndex = index + direccion;
    if (otroIndex < 0 || otroIndex >= servicios.length) return;

    const actual = servicios[index];
    const otro = servicios[otroIndex];

    try {
      await axios.post(`${API_URL}/api/servicios/${actual.id}/orden`, { orden: otro.orden });
      await axios.post(`${API_URL}/api/servicios/${otro.id}/orden`, { orden: actual.orden });
      cargarServicios();
    } catch (err) {
      alert(err.response?.data?.message || "No se pudo cambiar el orden");
    }
  };

  /* =======================
     ELIMINAR
  ======================== */
  const eliminarServicio = async (id) => {
    if (!window.confirm("¿Eliminar servicio?")) return;
    try {
      await axios.post(`${API_URL}/api/servicios/${id}/eliminar`);
      cargarServicios();
    } catch (err) {
      alert(err.response?.data?.message || "No se pudo eliminar el servicio");
    }
  };

  /* =======================
     ACTIVAR / DESACTIVAR
  ======================== */
  const toggleActivo = async (s) => {
    try {
      await axios.post(`${API_URL}/api/servicios/${s.id}/habilitar`, {
        habilitado: !s.habilitado,
      });
      cargarServicios();
    } catch (err) {
      alert(err.response?.data?.message || "No se pudo actualizar el servicio");
    }
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-indigo-100 p-3 md:p-8">
      <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center md:text-left">🛠 Gestión de Servicios</h2>

      {/* FORMULARIO */}
      {(modo === "crear" || modo === "editar") && (
        <div className="bg-white rounded-2xl shadow-xl p-6 max-w-lg mb-8 border">
          <h3 className="text-lg font-semibold mb-4">
            {modo === "crear" ? "➕ Nuevo Servicio" : "✏️ Editar Servicio"}
          </h3>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Nombre</label>
              <input
                className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium">Tipo de servicio (Ruta)</label>
              <select
                className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500"
                value={ruta}
                onChange={(e) => setRuta(e.target.value)}
              >
                <option value="">Selecciona un tipo...</option>
                {RUTAS_VALIDAS.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Determina qué pantalla ve el padre (lista de profesores de
                Colegio, CDA o Kindergarten). Puedes ponerle el nombre que
                quieras arriba (ej. "Citas Tercer Corte"), esto solo define
                cuál de las 3 pantallas usa.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium">Color</label>
              <div className="flex items-center gap-2 mt-1">
                <input
                  type="color"
                  className="h-10 w-20"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                />
                <input
                  type="text"
                  className="px-2 py-1 border rounded-lg font-mono text-sm w-28"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                />
              </div>
              <label className="flex items-center gap-2 mt-2 text-sm text-slate-600 cursor-pointer">
                <input
                  type="checkbox"
                  checked={colorDifuminado}
                  onChange={(e) => setColorDifuminado(e.target.checked)}
                />
                Difuminado
              </label>
            </div>

            <div>
              <label className="block text-sm font-medium">Imagen</label>
              <input type="file" accept="image/*" onChange={onImagenChange} />
            </div>

            {preview && (
              <img
                src={preview}
                alt="preview"
                className="w-36 rounded-xl border shadow"
              />
            )}
          </div>

          <div className="mt-6 flex gap-3">
            <button
              onClick={modo === "crear" ? crearServicio : guardarEdicion}
              className="bg-indigo-600 text-white px-5 py-2 rounded-xl hover:bg-indigo-700"
            >
              💾 Guardar
            </button>
            <button
              onClick={resetForm}
              className="bg-slate-500 text-white px-5 py-2 rounded-xl hover:bg-slate-600"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* BOTÓN AGREGAR */}
      {modo === "listar" && (
        <button
          onClick={() => setModo("crear")}
          className="mb-6 bg-emerald-600 text-white px-6 py-3 rounded-xl hover:bg-emerald-700"
        >
          ➕ Agregar servicio
        </button>
      )}

      {/* TABLA — solo escritorio */}
      <div className="hidden md:block bg-white rounded-2xl shadow-xl overflow-x-auto border">
        <table className="w-full border-collapse">
          <thead className="bg-indigo-600 text-white">
            <tr>
              <th className="border px-4 py-3 text-left">ID</th>
              <th className="border px-4 py-3 text-left">Nombre</th>
              <th className="border px-4 py-3 text-left">Color</th>
              <th className="border px-4 py-3 text-left">Imagen</th>
              <th className="border px-4 py-3 text-left">Configuración</th>
              <th className="border px-4 py-3 text-left">Activo</th>
              <th className="border px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {servicios.map((s, i) => (
              <tr
                key={s.id}
                className="hover:bg-slate-100 transition"
              >
                <td className="border px-4 py-2">{s.id}</td>
                <td className="border px-4 py-2">{s.nombre}</td>
                <td className="border px-4 py-2">
                  <div
                    className="w-8 h-5 rounded"
                    style={{ background: armarFondo(s.color, s.color_difuminado) }}
                  />
                </td>
                <td className="border px-4 py-2">
                  {s.imagen && (




<img
  src={`${API_BASE}${s.imagen}?t=${Date.now()}`}
  alt=""
  className="w-12 rounded-lg"
/>

                    
                  )}
                </td>
                <td className="border px-4 py-2">
                  <select
                    value={s.configuracion_id || ""}
                    onChange={(e) =>
                      asignarConfiguracion(s.id, e.target.value || null)
                    }
                    className="border p-1 rounded text-sm"
                  >
                    <option value="">Sistema anterior</option>
                    {configuraciones.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.nombre}
                      </option>
                    ))}
                  </select>
                </td>
                <td
                  className={`border px-4 py-2 font-semibold ${
                    s.habilitado ? "text-emerald-600" : "text-red-600"
                  }`}
                >
                  {s.habilitado ? "Sí" : "No"}
                </td>
                <td className="border px-4 py-2 text-center space-x-2">
                  <button
                    onClick={() => moverOrden(i, -1)}
                    disabled={i === 0}
                    className="disabled:opacity-30 disabled:cursor-not-allowed"
                    title="Subir"
                  >
                    ⬆️
                  </button>
                  <button
                    onClick={() => moverOrden(i, 1)}
                    disabled={i === servicios.length - 1}
                    className="disabled:opacity-30 disabled:cursor-not-allowed"
                    title="Bajar"
                  >
                    ⬇️
                  </button>
                  <button onClick={() => abrirEditar(s)}>✏️</button>
                  <button onClick={() => eliminarServicio(s.id)}>🗑</button>
                  <button onClick={() => toggleActivo(s)}>
                    {s.habilitado ? "🚫" : "✅"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* TARJETAS — solo móvil */}
      <div className="md:hidden flex flex-col gap-3">
        {servicios.map((s, i) => (
          <div
            key={s.id}
            className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex flex-col gap-3"
            style={{ borderLeft: `4px solid ${s.habilitado ? "#059669" : "#dc2626"}` }}
          >
            <div className="flex items-center gap-3">
              {s.imagen && (
                <img
                  src={`${API_BASE}${s.imagen}?t=${Date.now()}`}
                  alt=""
                  className="w-12 h-12 rounded-lg object-contain bg-slate-50 border flex-shrink-0"
                />
              )}
              <div className="min-w-0 flex-1">
                <p className="font-bold text-gray-800 truncate">{s.nombre}</p>
                <div className="flex items-center gap-2 mt-1">
                  <div
                    className="w-6 h-4 rounded flex-shrink-0"
                    style={{ background: armarFondo(s.color, s.color_difuminado) }}
                  />
                  <span className={`text-xs font-semibold ${s.habilitado ? "text-emerald-600" : "text-red-600"}`}>
                    {s.habilitado ? "Activo" : "Inactivo"}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <label className="block text-xs text-gray-400 mb-1">Configuración</label>
              <select
                value={s.configuracion_id || ""}
                onChange={(e) => asignarConfiguracion(s.id, e.target.value || null)}
                className="w-full border border-gray-300 p-2 rounded-lg text-sm"
              >
                <option value="">Sistema anterior</option>
                {configuraciones.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => moverOrden(i, -1)}
                disabled={i === 0}
                className="bg-slate-200 hover:bg-slate-300 disabled:opacity-30 disabled:cursor-not-allowed px-3 py-2 rounded-lg text-sm font-semibold"
                title="Subir"
              >
                ⬆️
              </button>
              <button
                onClick={() => moverOrden(i, 1)}
                disabled={i === servicios.length - 1}
                className="bg-slate-200 hover:bg-slate-300 disabled:opacity-30 disabled:cursor-not-allowed px-3 py-2 rounded-lg text-sm font-semibold"
                title="Bajar"
              >
                ⬇️
              </button>
              <button
                onClick={() => abrirEditar(s)}
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-2 rounded-lg text-sm font-semibold"
              >
                ✏️ Editar
              </button>
              <button
                onClick={() => toggleActivo(s)}
                className="flex-1 bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-lg text-sm font-semibold"
              >
                {s.habilitado ? "🚫 Desactivar" : "✅ Activar"}
              </button>
              <button
                onClick={() => eliminarServicio(s.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg text-sm font-semibold"
              >
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GestionarServicios;
